// Generated from design-system/tokens/themes.json (par-002.v1). Do not edit manually.
export interface ThemeDefinition {
  readonly id: string;
  readonly name: string;
  readonly category: string;
  readonly primary: string;
  readonly onPrimary: string;
  readonly surface: string;
  readonly elevated: string;
  readonly text: string;
  readonly muted: string;
  readonly border: string;
}

// iOS product theme, separate from the 30 portable canonical variants.
export const showcaseBaseTheme: ThemeDefinition = {
  id: "showcase-base", name: "DS Showcase", category: "Producto", primary: "#3157d5",
  onPrimary: "#ffffff", surface: "#f4f7fb", elevated: "#ffffff",
  text: "#122033", muted: "#536273", border: "#cfd8e6",
};

export const themes: ReadonlyArray<ThemeDefinition> = [
  {
    id: "libertad",
    name: "Libertad",
    category: "Producto",
    primary: "#4756d8",
    onPrimary: "#ffffff",
    surface: "#f7f7fb",
    elevated: "#ffffff",
    text: "#191a20",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "atlantic",
    name: "Atlántico",
    category: "Producto",
    primary: "#005b96",
    onPrimary: "#ffffff",
    surface: "#f2f8fc",
    elevated: "#ffffff",
    text: "#10212b",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "forest",
    name: "Bosque",
    category: "Producto",
    primary: "#216e4e",
    onPrimary: "#ffffff",
    surface: "#f2f7f3",
    elevated: "#ffffff",
    text: "#15231b",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "ember",
    name: "Brasa",
    category: "Producto",
    primary: "#a83220",
    onPrimary: "#ffffff",
    surface: "#fff6f1",
    elevated: "#ffffff",
    text: "#2c1711",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "plum",
    name: "Ciruela",
    category: "Producto",
    primary: "#71368f",
    onPrimary: "#ffffff",
    surface: "#fcf6ff",
    elevated: "#ffffff",
    text: "#28152f",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "cobalt",
    name: "Cobalto",
    category: "Profesional",
    primary: "#1647a5",
    onPrimary: "#ffffff",
    surface: "#f5f7fc",
    elevated: "#ffffff",
    text: "#101b31",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "graphite",
    name: "Grafito",
    category: "Profesional",
    primary: "#37474f",
    onPrimary: "#ffffff",
    surface: "#f5f6f6",
    elevated: "#ffffff",
    text: "#171c1e",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "burgundy",
    name: "Borgoña",
    category: "Profesional",
    primary: "#7f1d3f",
    onPrimary: "#ffffff",
    surface: "#fcf5f7",
    elevated: "#ffffff",
    text: "#2d151d",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "navy",
    name: "Náutico",
    category: "Profesional",
    primary: "#153a66",
    onPrimary: "#ffffff",
    surface: "#f4f7fa",
    elevated: "#ffffff",
    text: "#101c29",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "sage",
    name: "Salvia",
    category: "Profesional",
    primary: "#506b55",
    onPrimary: "#ffffff",
    surface: "#f7f8f3",
    elevated: "#ffffff",
    text: "#1c241d",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "candy",
    name: "Caramelo",
    category: "Expresivo",
    primary: "#bd1452",
    onPrimary: "#ffffff",
    surface: "#fff4f8",
    elevated: "#ffffff",
    text: "#301421",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "citrus",
    name: "Cítrico",
    category: "Expresivo",
    primary: "#626700",
    onPrimary: "#ffffff",
    surface: "#ffffed",
    elevated: "#ffffff",
    text: "#222400",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "lagoon",
    name: "Laguna",
    category: "Expresivo",
    primary: "#00747f",
    onPrimary: "#ffffff",
    surface: "#eefcfd",
    elevated: "#ffffff",
    text: "#08282b",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "coral",
    name: "Coral",
    category: "Expresivo",
    primary: "#ae3045",
    onPrimary: "#ffffff",
    surface: "#fff4f4",
    elevated: "#ffffff",
    text: "#321317",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "violet",
    name: "Violeta",
    category: "Expresivo",
    primary: "#6d28d9",
    onPrimary: "#ffffff",
    surface: "#faf7ff",
    elevated: "#ffffff",
    text: "#211334",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "paper",
    name: "Papel",
    category: "Editorial",
    primary: "#4e443c",
    onPrimary: "#ffffff",
    surface: "#fffbf2",
    elevated: "#ffffff",
    text: "#251f1a",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "ink",
    name: "Tinta",
    category: "Editorial",
    primary: "#243447",
    onPrimary: "#ffffff",
    surface: "#f7f3ea",
    elevated: "#ffffff",
    text: "#18212a",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "museum",
    name: "Museo",
    category: "Editorial",
    primary: "#5b3a29",
    onPrimary: "#ffffff",
    surface: "#fbf6e9",
    elevated: "#ffffff",
    text: "#261a14",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "bauhaus",
    name: "Bauhaus",
    category: "Editorial",
    primary: "#b71c1c",
    onPrimary: "#ffffff",
    surface: "#fff9e7",
    elevated: "#ffffff",
    text: "#211a0b",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "mono",
    name: "Monocromo",
    category: "Editorial",
    primary: "#202124",
    onPrimary: "#ffffff",
    surface: "#ffffff",
    elevated: "#ffffff",
    text: "#202124",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "midnight",
    name: "Medianoche",
    category: "Oscuro",
    primary: "#b9beff",
    onPrimary: "#111111",
    surface: "#11131a",
    elevated: "#171922",
    text: "#f0f1f8",
    muted: "#d2d3dc",
    border: "#555866",
  },
  {
    id: "aurora",
    name: "Aurora",
    category: "Oscuro",
    primary: "#70e1f5",
    onPrimary: "#111111",
    surface: "#101b26",
    elevated: "#172532",
    text: "#f1f7fa",
    muted: "#d2d3dc",
    border: "#555866",
  },
  {
    id: "neon",
    name: "Neón",
    category: "Oscuro",
    primary: "#b7ff00",
    onPrimary: "#111111",
    surface: "#101010",
    elevated: "#191919",
    text: "#f5f5f5",
    muted: "#d2d3dc",
    border: "#555866",
  },
  {
    id: "espresso",
    name: "Espresso",
    category: "Oscuro",
    primary: "#ffb77a",
    onPrimary: "#111111",
    surface: "#1f1814",
    elevated: "#2a211c",
    text: "#fff2e9",
    muted: "#d2d3dc",
    border: "#555866",
  },
  {
    id: "galaxy",
    name: "Galaxia",
    category: "Oscuro",
    primary: "#c4b5fd",
    onPrimary: "#111111",
    surface: "#171126",
    elevated: "#211a32",
    text: "#f5f0ff",
    muted: "#d2d3dc",
    border: "#555866",
  },
  {
    id: "hc-light",
    name: "Contraste claro",
    category: "Accesible",
    primary: "#0000b8",
    onPrimary: "#ffffff",
    surface: "#ffffff",
    elevated: "#ffffff",
    text: "#000000",
    muted: "#000000",
    border: "#000000",
  },
  {
    id: "hc-dark",
    name: "Contraste oscuro",
    category: "Accesible",
    primary: "#ffff00",
    onPrimary: "#000000",
    surface: "#000000",
    elevated: "#171717",
    text: "#ffffff",
    muted: "#ffffff",
    border: "#ffffff",
  },
  {
    id: "focus",
    name: "Foco",
    category: "Accesible",
    primary: "#d2b8ff",
    onPrimary: "#21103a",
    surface: "#111111",
    elevated: "#211b2b",
    text: "#ffffff",
    muted: "#ffffff",
    border: "#ffffff",
  },
  {
    id: "calm",
    name: "Calma",
    category: "Accesible",
    primary: "#245b78",
    onPrimary: "#ffffff",
    surface: "#f8fbfc",
    elevated: "#ffffff",
    text: "#152027",
    muted: "#565965",
    border: "#c8cad5",
  },
  {
    id: "warm",
    name: "Cálido",
    category: "Accesible",
    primary: "#8c3b12",
    onPrimary: "#ffffff",
    surface: "#fffaf5",
    elevated: "#ffffff",
    text: "#29170e",
    muted: "#565965",
    border: "#c8cad5",
  },
];

export function themeById(id: string): ThemeDefinition {
  if (id === showcaseBaseTheme.id) return showcaseBaseTheme;
  return themes.find((theme) => theme.id === id) ?? themes[0]!;
}

export function applyTheme(theme: ThemeDefinition, target: HTMLElement = document.documentElement): void {
  target.dataset.theme = theme.id;
  target.style.setProperty("--ds-color-primary", theme.primary);
  target.style.setProperty("--ds-color-on-primary", theme.onPrimary);
  target.style.setProperty("--ds-color-surface", theme.surface);
  target.style.setProperty("--ds-color-elevated", theme.elevated);
  target.style.setProperty("--ds-color-text", theme.text);
  target.style.setProperty("--ds-color-muted", theme.muted);
  target.style.setProperty("--ds-color-border", theme.border);
}
